import { useRef } from 'react';
import { ShopOnboardingID } from '@prisma/client';
import PageLayout from '../components/global/PageLayout';
import PageLoading from '../components/global/PageLoading';
import AdsSetupAccordion from '../components/marketing/AdsSetupAccordion';
import PocketflowsEmbed from '../components/marketing/PocketflowsEmbed';
import useGetMarketingData from '../hooks/marketing/useGetMarketingData';
import useFeatureGuard from '../hooks/subscriptions/useFeatureGuard';
import useUser from '../hooks/global/useUser';
import { Feature } from '../types/subscriptions';
import { hasAdsAccess } from '../helpers/ads';
import OnboardingBanner from '../components/onboarding/OnboardingBanner';
import CustomerSideBarModal from '../components/customers/CustomerSideBarModal';
import useConversionCustomer from '../hooks/marketing/useConversionCustomer';

export default function AdsPage() {
  const { data: marketingData, isLoading } = useGetMarketingData();
  const accordionRef = useRef<HTMLDivElement>(null);
  const { user } = useUser();
  const canAccessAds = useFeatureGuard(Feature.ADS);
  const isAllowed = hasAdsAccess(user, canAccessAds);
  const { customerId, clearCustomer } = useConversionCustomer();

  const embedId = marketingData?.sourceEmbedId;

  return (
    <PageLayout
      withoutChildContainer
      headerIsHidden
      guard={{ isAllowed }}
      topSection={
        <OnboardingBanner step={ShopOnboardingID.ADS} completeOnRender />
      }>
      {(isLoading || !embedId) && <PageLoading />}
      {!isLoading && embedId && (
        <>
          <div ref={accordionRef}>
            <AdsSetupAccordion />
          </div>
          <PocketflowsEmbed
            embedId={embedId}
            path="ads"
            title="Ads"
            anchorRef={accordionRef}
          />
        </>
      )}
      <CustomerSideBarModal
        customerId={customerId}
        isOpen={!!customerId}
        onClose={clearCustomer}
      />
    </PageLayout>
  );
}
